(function () {
  "use strict";

  const config = {
    form: "#create_customer",
    fields: {
      firstName: {
        selector: "#first_name",
        minLength: 2,
      },
      lastName: {
        selector: "#last_name",
        minLength: 2,
      },
      email: {
        selector: "#email",
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      },
      password: {
        selector: "#password",
        minLength: 6,
      },
      privacyPolicy: {
        selector: "#privacy-policy",
      },
    },
  };

  document.addEventListener("DOMContentLoaded", initFormValidation);

  function initFormValidation() {
    const form = document.querySelector(config.form);
    if (!form) throw "Register form not provided";

    addRealTimeValidation(form);
    form.addEventListener("submit", handleFormSubmit);
  }

  function addRealTimeValidation(form) {
    for (const fieldKey in config.fields) {
      const fieldConfig = config.fields[fieldKey];
      const field = form.querySelector(fieldConfig.selector);
      if (!field) continue;

      // Debounce
      let timeout;
      field.addEventListener("input", function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          validateField(field, fieldConfig, false);
        }, 300);
      });

      // User moves away from the input
      field.addEventListener("blur", function () {
        validateField(field, fieldConfig, true);
      });
    }
  }

  function validateField(field, fieldConfig) {
    const fieldContainer = field.closest(".form-field");
    const value =
      "checkbox" === field.type ? field.checked : field.value.trim();
    let isValid = true;

    clearFieldError(fieldContainer);

    if ("checkbox" === field.type) {
      if (!field.checked) isValid = false;
    } else if (!value || value === "") isValid = false;


    if (isValid && value && field.type !== "checkbox") {
      if (fieldConfig.minLength && value.length < fieldConfig.minLength) isValid = false;

      // Pattern check (email)
      if (fieldConfig.pattern && !fieldConfig.pattern.test(value)) isValid = false;
    }

    if (!isValid) showFieldError(fieldContainer);

    return isValid;
  }

  function showFieldError(fieldContainer) {
    const existingError = fieldContainer.querySelector(".error-message");
    if (!existingError) return;
    existingError.classList.remove('hidden');
  }

  function clearFieldError(fieldContainer) {
    const existingError = fieldContainer.querySelector(".error-message");
    if (!existingError) return;
    existingError.classList.add('hidden');
  }

  function handleFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    let isFormValid = true;

    for (const fieldKey in config.fields) {
      const fieldConfig = config.fields[fieldKey];
      const field = form.querySelector(fieldConfig.selector);

      if (!field) continue;

      const isFieldValid = validateField(field, fieldConfig, true);
      if (isFieldValid) continue;
      isFormValid = false;
    }

    if (isFormValid) {
      form.removeEventListener("submit", handleFormSubmit);
      form.submit();
      return;
    }

    // Fly to first error available
    const firstErrorField = form.querySelector(
      '.form-field.error input, .form-field.error input[type="checkbox"]'
    );
    if (!firstErrorField) return;
    firstErrorField.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    firstErrorField.focus();
  }

  window.FormValidator = {
    validateForm: function () {
      const form = document.querySelector(config.form);
      if (form) handleFormSubmit({ target: form, preventDefault: () => {} });
    },
    clearValidation: function () {
      const form = document.querySelector(config.form);
      if (form) clearFormSummary(form);
    },
  };
})();
